"use client";

import Link from "@/components/ui/Link";
import { useUi } from "@/components/ui/use-ui";
import { cn } from "@/lib/cn";

export function Logo({ className, height = 34 }: { className?: string; height?: number }) {
  const t = useUi();
  return (
    <Link href="/" aria-label={t.actions.home} className={cn("inline-flex shrink-0 items-center", className)}>
      {/* eslint-disable-next-line @next/next/no-img-element -- small static brand asset with a hand-made srcset */}
      <img
        src="/brand/logo.webp"
        srcSet="/brand/logo.webp 1x, /brand/logo@2x.webp 2x"
        alt="Sweet"
        height={height}
        width={Math.round(height * 2.146)}
        style={{ height, width: "auto" }}
        className="logo-dark drop-shadow-[0_0_12px_rgb(255_31_90/0.25)]"
      />
      {/* The light theme's: the wordmark in cherry instead of pale pink (globals.css shows one or the other). */}
      {/* eslint-disable-next-line @next/next/no-img-element -- small static brand asset with a hand-made srcset */}
      <img
        src="/brand/logo-light.webp"
        srcSet="/brand/logo-light.webp 1x, /brand/logo-light@2x.webp 2x"
        alt="Sweet"
        height={height}
        width={Math.round(height * 2.146)}
        style={{ height, width: "auto" }}
        className="logo-light"
        loading="lazy"
      />
    </Link>
  );
}
